import { faBoxesStacked } from '@fortawesome/pro-light-svg-icons';
import { faBoxesStacked as faBoxesStackedSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/ui/Flex';
import Text from 'components/ui/Text';
import { useTranslation } from 'react-i18next';
import { ReturnItem } from 'returnCenter-api';
import styled from 'styled-components';
import { LIGHT_BLUE } from 'styles/globalstyles';

type BatchReturnIndicatorCellProps = {
    item: ReturnItem;
    onClick: () => void;
    destinationName?: string;
    disabled?: boolean;
};

const BatchReturnIndicatorCell = ({ item, onClick, destinationName, disabled }: BatchReturnIndicatorCellProps) => {
    const { t } = useTranslation();
    const isAssigned = item.batchReturnId != null;
    const isEligible = item.batchReturnDestinationId != null;

    if (!isEligible) return null;

    const icon = isAssigned ? faBoxesStackedSolid : faBoxesStacked;
    const color = isAssigned ? '#4caf50' : '#9e9e9e';
    const label = isAssigned
        ? `${destinationName ?? t('batchReturn.assigned', 'Assigned')} #${item.batchReturnId}`
        : t('batchReturn.unassigned', 'Unassigned');
    const tooltip = destinationName
        ? `${t('batchReturn.destination', 'Destination')}: ${destinationName}`
        : label;

    return (
        <StyledButton onClick={onClick} disabled={disabled} title={tooltip}>
            <StyledFlex>
                <FontAwesomeIcon icon={icon} color={color} fontSize={14} />
                <StyledText $color={color}>{label}</StyledText>
            </StyledFlex>
        </StyledButton>
    );
};

const StyledButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.15s;

    &:hover:not(:disabled) {
        background-color: rgba(0, 0, 0, 0.04);
    }

    &:disabled {
        cursor: default;
        opacity: 0.5;
    }
`;

const StyledFlex = styled(Flex)`
    align-items: center;
    gap: 4px;
`;

const StyledText = styled(Text)<{ $color?: string }>`
    font-size: 11px;
    color: ${(props) => props.$color ?? 'inherit'};
    white-space: nowrap;
`;

export default BatchReturnIndicatorCell;
